// @ts-nocheck
/* global require */
window.Quantumart = window.Quantumart || {};
window.Quantumart.QP8 = window.Quantumart.QP8 || {};

require('./BackendLogin.js');



// WEBPACK FOOTER //
// ./Scripts/Quantumart/AppLogon.js